import React from 'react';
import MapComponent from './MapComponent';
import './App.css';

function App() {
  return (
    <div className="App">
      <MapComponent />
    </div>
  );
}

export default App;